__turbopack_context__.v({
  "quote-block": "QuoteBlock-module-scss-module__hQo-Aq__quote-block",
  "quote-block--dawn": "QuoteBlock-module-scss-module__hQo-Aq__quote-block--dawn",
  "quote-block--dawn-2": "QuoteBlock-module-scss-module__hQo-Aq__quote-block--dawn-2",
  "quote-block--dusk": "QuoteBlock-module-scss-module__hQo-Aq__quote-block--dusk",
  "quote-block--light-dusk": "QuoteBlock-module-scss-module__hQo-Aq__quote-block--light-dusk",
  "quote-block--midnight": "QuoteBlock-module-scss-module__hQo-Aq__quote-block--midnight",
  "quote-block--midnight-2": "QuoteBlock-module-scss-module__hQo-Aq__quote-block--midnight-2",
  "quote-block--warm-red": "QuoteBlock-module-scss-module__hQo-Aq__quote-block--warm-red",
  "quote-block__button": "QuoteBlock-module-scss-module__hQo-Aq__quote-block__button",
  "quote-block__button--next": "QuoteBlock-module-scss-module__hQo-Aq__quote-block__button--next",
  "quote-block__button--prev": "QuoteBlock-module-scss-module__hQo-Aq__quote-block__button--prev",
  "quote-block__button-inner": "QuoteBlock-module-scss-module__hQo-Aq__quote-block__button-inner",
  "quote-block__dot": "QuoteBlock-module-scss-module__hQo-Aq__quote-block__dot",
  "quote-block__dot--active": "QuoteBlock-module-scss-module__hQo-Aq__quote-block__dot--active",
  "quote-block__dots": "QuoteBlock-module-scss-module__hQo-Aq__quote-block__dots",
  "quote-block__heading": "QuoteBlock-module-scss-module__hQo-Aq__quote-block__heading",
  "quote-block__inner": "QuoteBlock-module-scss-module__hQo-Aq__quote-block__inner",
  "quote-block__track": "QuoteBlock-module-scss-module__hQo-Aq__quote-block__track",
  "quote-block__track-wrapper": "QuoteBlock-module-scss-module__hQo-Aq__quote-block__track-wrapper",
  "quote-item": "QuoteBlock-module-scss-module__hQo-Aq__quote-item",
  "quote-item__body": "QuoteBlock-module-scss-module__hQo-Aq__quote-item__body",
  "quote-item__caption": "QuoteBlock-module-scss-module__hQo-Aq__quote-item__caption",
});
